import { FC, lazy } from "react";

const SellerAppWithAuthAndStore = lazy(
  () => import("@topi/seller/seller-app-with-auth-and-store")
);

const CheckoutAppWithStore = lazy(
  () => import("@topi/checkout/checkout-app-with-store")
);

const ECPortalAppWithAuthAndStore = lazy(
  () => import("@topi/ec-portal/ec-portal-app-with-auth-and-store")
);

export type AvailableAppNames = "checkout" | "seller" | "ec-portal";

interface AppProps {
  appType: AvailableAppNames;
}

export const App: FC<AppProps> = ({ appType }) => {
  switch (appType) {
    case "ec-portal":
      return <ECPortalAppWithAuthAndStore />;
    case "seller":
      return <SellerAppWithAuthAndStore />;
    case "checkout":
      return <CheckoutAppWithStore />;
    default:
      throw new Error(`Unknown app type: ${appType}`);
  }
};
